import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getVerticalWallArea as c } from "../total-metrics/index59.js";
import { getRgObjectsAtLevel as i } from "../../../utils/rg-util/index3.js";
import { isServiceTechSpace as o } from "../../queries/index7.js";
const f = (e, r) => c(i(e, t.TechnicalSpace, r).filter(o));
export {
  f as getLevelServicesWallArea
};
//# sourceMappingURL=index32.js.map
